// src/admin/Admin.js
import React from 'react';
import { Routes, Route } from 'react-router';
import Login from './Login';
import Dashboard from './Dashboard';

const Admin = () => {
  return (
    <div className='container'>
      <h2>Admin Dashboard</h2>

      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="login" element={<Login />} />
      </Routes>
    </div>
  );
}

export default Admin;
